import { gql } from "@apollo/client";

export const getClassroomClashesQuery = gql`
  query getClassroomClashes(
    $originId: ID!
    $scenarioId: ID!
    $filter: ClassroomBookingClashesFilterInput
  ) {
    cube(originId: $originId, scenarioId: $scenarioId) {
      classroomBookingClashes(filter: $filter) {
        items {
          session {
            id
            links {
              id
              course {
                id
                name
              }
            }
          }
          classroomBooking {
            id
            title
            description
          }
          classroom {
            id
            name
            code
          }
          dateAvailability
        }
        pageInfo {
          total
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;
